import React, { useState, useEffect, forwardRef, useRef } from "react";
import { Button, Container, FormGroup, Input, Row, Label } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import { Eye, EyeOff, DateCalender, XIcon } from "assets";
import { Sort, Bell, Import } from "assets";
import { FiArrowLeft } from "react-icons/fi";
import { MdOutlineDateRange } from "react-icons/md";
import CustomButton from "components/CustomButton";
import { FormCreatableSelects, FormInputs, FormSelects } from "components/FormInputSelect";
import CustomInput from "pages/auth/CustomInput";
import { API_GET_MAMBOO, API_POST_MAMBOO, API_PUT_MAMBOO } from "services";
import Swal from "sweetalert2";
import formValidator from "services/validator";
import {
  DATE_PICKER_FORMAT,
  DATE_PLACEHOLDER,
  fromDisplayDate,
  toDisplayDate,
} from "utils/date";

const AddAnggota = ({ handleBack, detailPencipta, isEdit, isReadOnly }) => {
  const [addAnggotaForm, setAddAnggotaForm] = useState({
    name: (detailPencipta && detailPencipta?.name) || "",
    ip_base_number: (detailPencipta && detailPencipta?.ip_base_number) || "I-",
    popular_name: "",
    ip_name_number: "",
    email: (detailPencipta && detailPencipta?.email) || "",
    address: (detailPencipta && detailPencipta?.address) || "",
    phone_number: (detailPencipta && detailPencipta?.phone_number) || "",
    place_of_birth: (detailPencipta && detailPencipta?.place_of_birth) || "",
    date_of_birth: toDisplayDate(detailPencipta?.date_of_birth),
    identity_number: (detailPencipta && detailPencipta?.identity_number) || "",
    npwp_number: (detailPencipta && detailPencipta?.npwp_number) || "",
    bps_number: (detailPencipta && detailPencipta?.bps_number) || "",
    bank:
      (detailPencipta &&
        detailPencipta?.bank_accounts &&
        detailPencipta?.bank_accounts?.bank) ||
      "",
    account_name:
      (detailPencipta &&
        detailPencipta?.bank_accounts &&
        detailPencipta?.bank_accounts?.account_name) ||
      "",
    account_number:
      (detailPencipta &&
        detailPencipta?.bank_accounts &&
        detailPencipta?.bank_accounts?.account_number) ||
      "",
    documents: (detailPencipta && detailPencipta?.documents) || [],
  });
  const [addAhliWarisForm, setAddAhliWarisForm] = useState({
    name_pencipta: "",
    ip_base_number_pencipta: "I-",
    popular_name_pencipta: "",
    address_pencipta: "",
    phone_number_pencipta: "",
    place_of_birth_pencipta: "",
    date_of_birth_pencipta: "",
    date_of_death_pencipta: "",
    identity_number_pencipta: "",
    name_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.name || "",
    email_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.email || "",
    address_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.address || "",
    phone_number_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.phone_number || "",
    place_of_birth_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.place_of_birth || "",
    date_of_birth_ahli_waris: toDisplayDate(detailPencipta?.ahli_waris?.date_of_birth),
    identity_number_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.identity_number || "",
    npwp_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.npwp_number || "",
    bank_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.bank_accounts && detailPencipta?.ahli_waris?.bank_accounts?.bank || "",
    account_name_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.bank_accounts && detailPencipta?.ahli_waris?.bank_accounts?.account_name || "",
    account_number_ahli_waris: detailPencipta && detailPencipta?.ahli_waris?.bank_accounts && detailPencipta?.ahli_waris?.bank_accounts?.account_number || "",
    documents: detailPencipta && detailPencipta?.ahli_waris?.documents || []
  })
  const [isRole, setIsRole] = useState([]);
  const [isValueRole, setIsValueRole] = useState({
    label: (detailPencipta && detailPencipta?.role) || (detailPencipta && detailPencipta?.ahli_waris?.role) || null,
    value: (detailPencipta && detailPencipta?.role_code) || (detailPencipta && detailPencipta?.ahli_waris?.role_code) || null,
  });
  const [namaPopuler, setNamaPopuler] = useState([]);
  const [namaPopulerWithIpNumber, setNamaPopulerWithIpNumber] = useState(
    (detailPencipta && detailPencipta?.popular_data) || []
  );
  const [filePreviewUrl, setFilePreviewUrl] = useState({});
  const [isIndex, setIsIndex] = useState();
  const [isFileChoose, setIsFileChoose] = useState({
    ktp: {},
    bps: {},
    npwp: {},
    lainnya: {},
    ahli_waris: {},
  });
  const [isEnabledCheckbox, setIsEnabledCheckbox] = useState(false);
  const [isOptionsPencipta, setIsOptionsPencipta] = useState([]);
  const [isPencipta, setIsPencipta] = useState({
    label: (isEdit && detailPencipta && detailPencipta?.pencipta?.name) || null,
    value: (isEdit && detailPencipta && detailPencipta?.pencipta?.user_id) || null
  });
  const [listBank, setListBank] = useState([])
  const [isDisable, setIsDisable] = useState(false)
  const [validasiNpwpPencipta, setValidasiNpwpPencipta] = useState(false)
  const [validasiNpwpAhliwaris, setValidasiNpwpAhliWaris] = useState(false)
  const [validasiKtpPencipta, setValidasiKtpPencipta] = useState(false)
  const [validasiKtpAhliWaris, setValidasiKtpAhliWaris] = useState(false)
  const [validasiKtpPenciptaAsAhliWaris, setValidasiKtpPenciptaAsAhliWaris] = useState(false)


  const validationNumber = /^\d+$/;
  const validationAbjad = /^[a-zA-Z ]+$/;

  // Seluruh field selain "Registrasi Sebagai" baru aktif setelah peran dipilih,
  // karena struktur payload dan form yang dipakai bergantung pada role_code.
  const isFieldDisabled = isReadOnly || !isValueRole.value;

  const formatIpBaseNumber = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 10)
    if (digits.length === 0) return 'I-'
    if (digits.length <= 9) return `I-${digits}`
    return `I-${digits.slice(0, 9)}-${digits.slice(9, 10)}`
  }
  const [pencipta, setPencipta] = useState([])
  const customStylesNama = {
    control: (provided, state) => ({
      ...provided,
      borderRight: "1px solid var(--border-strong)",
      borderRadius: "8px",
      background: 'transparent',
      outline: 'none'
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
      color: 'var(--text-primary)',
      width: "176px",
      border: "none",
      outline: "none"
    }),
    singleValue: (state) => ({
      marginLeft: '16px',
      gridArea: '1/1/2/3',
      maxWidth: '100%',
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      color: "hsl(0, 0%, 20%)",
      marginLeft: "16px",
      marginRight: "2px",
      boxSizing: "border-box"
    }),
    placeholder: (provided, state) => ({
      ...provided,
      margin: "0px",
      paddingLeft: "16px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
  };

  const handleFileChoose = () => {
    if (addAnggotaForm.documents) {
      addAnggotaForm.documents.forEach((val) => {
        if (val.document_code === "KTP") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            ktp: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "NPWP Perusahaan") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            npwp: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "BPS") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            bps: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "Dokumen Lainnya") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            lainnya: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        }
      });
    }

    if (addAhliWarisForm.documents) {
      addAhliWarisForm.documents.forEach((val) => {
        if (val.document_code === "KTP") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            ktp: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "NPWP Perusahaan") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            npwp: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "BPS") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            bps: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "Dokumen Lainnya") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            lainnya: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        } else if (val.document_code === "Dokumen Penunjukan Ahli Waris") {
          setIsFileChoose((prevIsFileChoose) => ({
            ...prevIsFileChoose,
            ahli_waris: {
              link: val.document_url || null,
              label: val.document_code || "No File Choose",
            },
          }));
        }
      });
    }
  };

  const fileInputRef = useRef(null);

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const name = e.target.name;

    // console.log('kwkw', name, index)

    if (file) {
      let images = URL.createObjectURL(file);
      let isFilePreview = filePreviewUrl;
      isFilePreview[isIndex] = {
        name: file.name,
        data: images,
      };
      if (isValueRole.value == 3) {
        setAddAnggotaForm({ ...addAnggotaForm, [isIndex]: file });
      } else {
        setAddAhliWarisForm({ ...addAhliWarisForm, [isIndex]: file })
      }
    }
  };

  const handleButtonClick = (name) => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
      setIsIndex(name);
    }
  };

  const handleDateChange = (date, name) => {
    const formattedDate = toDisplayDate(date);
    if (isValueRole.value == 3) {
      setAddAnggotaForm({ ...addAnggotaForm, [name]: formattedDate });
    } else {
      setAddAhliWarisForm({ ...addAhliWarisForm, [name]: formattedDate });
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "5px",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      margin: "0px",
      padding: "16px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "ip_base_number") {
      const formatted = formatIpBaseNumber(value)
      setAddAnggotaForm({ ...addAnggotaForm, [name]: formatted });
      return;
    }
    if (name === "ip_base_number_pencipta") {
      const formatted = formatIpBaseNumber(value)
      setAddAhliWarisForm({ ...addAhliWarisForm, [name]: formatted });
      return;
    }
    if (isValueRole.value == 3) {
      if (
        ((name == "account_number" ||
          name == "npwp_number" ||
          name == "phone_number" ||
          name == "identity_number") &&
          validationNumber.test(value)) ||
        (name == "name" && validationAbjad.test(value)) ||
        ((name == "account_number" ||
          name == "npwp_number" ||
          name == "phone_number" ||
          name == "identity_number" ||
          name == "name") &&
          value == "")
      ) {
        setAddAnggotaForm({ ...addAnggotaForm, [name]: value });
      } else if (
        name != "account_number" &&
        name != "npwp_number" &&
        name != "phone_number" &&
        name != "identity_number" &&
        name != "name"
      ) {
        setAddAnggotaForm({ ...addAnggotaForm, [name]: value });
      }
    } else {
      if (
        ((name == "account_number_ahli_waris" ||
          name == "npwp_ahli_waris" ||
          name == "phone_number_ahli_waris" ||
          name == "identity_number_ahli_waris" ||
          name == "phone_number_pencipta" ||
          name == "identity_number_pencipta") &&
          validationNumber.test(value)) ||
        ((name == "name_pencipta" || name == "name_ahli_waris") &&
          validationAbjad.test(value)) ||
        ((name == "account_number_ahli_waris" ||
          name == "npwp_ahli_waris" ||
          name == "phone_number_ahli_waris" ||
          name == "identity_number_ahli_waris" ||
          name == "phone_number_pencipta" ||
          name == "identity_number_pencipta" ||
          name == "name_pencipta" ||
          name == "name_ahli_waris") &&
          value == "")
      ) {
        setAddAhliWarisForm({ ...addAhliWarisForm, [name]: value });
      } else if (
        name != "account_number_ahli_waris" &&
        name != "npwp_ahli_waris" &&
        name != "phone_number_ahli_waris" &&
        name != "identity_number_ahli_waris" &&
        name != "phone_number_pencipta" &&
        name != "identity_number_pencipta" &&
        name != "name_pencipta" &&
        name != "name_ahli_waris"
      ) {
        setAddAhliWarisForm({ ...addAhliWarisForm, [name]: value });
      }
    }
  };

  const onChangeSelect = (e) => {
    setIsValueRole({
      value: e.value,
      label: e.label,
    });
  };

  const onChangeCheckbox = (e) => {
    Swal.fire({
      icon: "question",
      // title: "Reset data",
      text: "Data yang sudah di isi akan di reset! Apakah anda yakin ?",
      showCancelButton: true,
      cancelButtonText: "Tidak",
      showConfirmButton: true,
      confirmButtonText: "Ya",
      confirmButtonColor: "#4dbd74",
    }).then((result) => {
      if(result.isConfirmed) {
        setIsEnabledCheckbox(e.target.checked);
        setIsPencipta({
          label: null,
          value: null
        })
        setAddAhliWarisForm({
          name_pencipta: "",
          ip_base_number_pencipta: "I-",
          popular_name_pencipta: "",
          address_pencipta: "",
          phone_number_pencipta: "",
          place_of_birth_pencipta: "",
          date_of_birth_pencipta: "",
          date_of_death_pencipta: "",
          identity_number_pencipta: "",
          name_ahli_waris: "",
          email_ahli_waris: "",
          address_ahli_waris: "",
          phone_number_ahli_waris: "",
          place_of_birth_ahli_waris: "",
          date_of_birth_ahli_waris: "",
          identity_number_ahli_waris: "",
          npwp_ahli_waris: "",
          bank_ahli_waris: "",
          account_name_ahli_waris: "",
          account_number_ahli_waris: "",
          documents: []
        })
      }
    })
    // setIsEnabledCheckbox(e.target.checked);
    // setIsPencipta({
    //   label: null,
    //   value: null
    // })
    // setAddAhliWarisForm({
    //   name_pencipta: "",
    //   ip_base_number_pencipta: "",
    //   popular_name_pencipta: "",
    //   address_pencipta: "",
    //   phone_number_pencipta: "",
    //   place_of_birth_pencipta: "",
    //   date_of_birth_pencipta: "",
    //   date_of_death_pencipta: "",
    //   identity_number_pencipta: "",
    //   name_ahli_waris: "",
    //   email_ahli_waris: "",
    //   address_ahli_waris: "",
    //   phone_number_ahli_waris: "",
    //   place_of_birth_ahli_waris: "",
    //   date_of_birth_ahli_waris: "",
    //   identity_number_ahli_waris: "",
    //   npwp_ahli_waris: "",
    //   bank_ahli_waris: "",
    //   account_name_ahli_waris: "",
    //   account_number_ahli_waris: "",
    //   documents: []
    // })
  };

  const onChangeIsPencipta = (e) => {
    setIsPencipta({
      value: e.value,
      label: e.label,
    });
  };

  const CustomInputDate = forwardRef(
    ({ value, onClick, onChange, placeholderText }, ref) => {
      return (
        <CustomInput
          value={value}
          className="frame-wrapper"
          onClick={onClick}
          iconAction={onClick}
          onChange={onChange}
          ref={ref}
          placeholder={DATE_PLACEHOLDER}
          iconPosition="right"
          Icon={DateCalender}
        />
      );
    }
  );

  const actionRolePencipta = () => {
    if (
      addAnggotaForm.popular_name ||
      (addAnggotaForm.popular_name && addAnggotaForm.ip_name_number)
    ) {
      setNamaPopulerWithIpNumber([
        ...namaPopulerWithIpNumber,
        {
          popular_name: addAnggotaForm.popular_name,
          ip_name_number: addAnggotaForm.ip_name_number,
        },
      ]);
      setAddAnggotaForm({
        ...addAnggotaForm,
        popular_name: "",
        ip_name_number: "",
      });
    }

    if (addAhliWarisForm.popular_name_pencipta) {
      setNamaPopuler([...namaPopuler, {
        popular_name: addAhliWarisForm.popular_name_pencipta,
        ip_name_number: ""
      }])
      setAddAhliWarisForm({ ...addAhliWarisForm, popular_name_pencipta: "" })
    }
  };

  const deleteActionRolePencipta = (index) => {
    if (isValueRole.value == 3) {
      const newData = [...namaPopulerWithIpNumber];
      newData.splice(index, 1);
      setNamaPopulerWithIpNumber(newData);
    }

    if (isValueRole.value == 7) {
      const newData = [...namaPopuler];
      newData.splice(index, 1);
      setNamaPopuler(newData);
    }
  };

  const namaPopulerWithIpNumberComponent = (value, index) => (
    <div className="judul-lain-component">
      <span className="text-judul">
        {value.ip_name_number
          ? `${value.popular_name} / ${value.ip_name_number}`
          : value.popular_name || value}
      </span>
      <span
        className="delete-icon"
        onClick={() => deleteActionRolePencipta(index)}
      >
        <XIcon />
      </span>
    </div>
  );

  const fetchingListRole = async () => {
    await API_GET_MAMBOO.dynamic
      .getLisUserByRoleCode("3", "", false, true)
      .then((response) => {
        const isData = response.map(({ creator_id, name }) => {
          return {
            label: name,
            value: creator_id,
          };
        });
        setIsOptionsPencipta(isData);
      })
      .catch((err) => {
        setIsOptionsPencipta([]);
      });
  };

  const keepOnlyNumbers = (inputString) => {
    return inputString?.replace(/[^0-9]/g, '');
}

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    let payload;

    if (isValueRole.value == 3) {
      if (isEdit) {
        payload = {
          name: addAnggotaForm.name,
          role_code: isValueRole.value,
          ip_base_number: addAnggotaForm.ip_base_number,
          address: addAnggotaForm.address,
          phone_number: addAnggotaForm.phone_number,
          place_of_birth: addAnggotaForm.place_of_birth,
          date_of_birth: addAnggotaForm.date_of_birth,
          identity_number: keepOnlyNumbers(addAnggotaForm.identity_number),
          bps_number: addAnggotaForm.bps_number,
          npwp_number: keepOnlyNumbers(addAnggotaForm.npwp_number),
          popular_data: namaPopulerWithIpNumber,
          email: addAnggotaForm.email,
          bank_data: {
            bank: addAnggotaForm.bank.value,
            account_name: addAnggotaForm.account_name,
            account_number: addAnggotaForm.account_number,
          },
        };
      } else {
        payload = {
          profile: {
            name: addAnggotaForm.name,
            role_code: isValueRole.value,
            ip_base_number: addAnggotaForm.ip_base_number,
            address: addAnggotaForm.address,
            phone_number: addAnggotaForm.phone_number,
            place_of_birth: addAnggotaForm.place_of_birth,
            date_of_birth: addAnggotaForm.date_of_birth,
            identity_number: keepOnlyNumbers(addAnggotaForm.identity_number),
            bps_number: addAnggotaForm.bps_number,
            npwp_number: keepOnlyNumbers(addAnggotaForm.npwp_number),
            popular_data: namaPopulerWithIpNumber,
          },
          bank_data: {
            bank: addAnggotaForm.bank.value,
            account_name: addAnggotaForm.account_name,
            account_number: addAnggotaForm.account_number,
          },
        };
      }

      data.append("payload", JSON.stringify(payload));
      if (!isEdit) {
        data.append("email", addAnggotaForm.email);
        data.append("password", addAnggotaForm.date_of_birth);
      } else {
        data.append("password", addAnggotaForm.date_of_birth);
      }

      if (addAnggotaForm["ktp"] instanceof File) {
        data.append("ktp", addAnggotaForm["ktp"]);
      }
      if (addAnggotaForm["npwp"] instanceof File) {
        data.append("npwp", addAnggotaForm["npwp"]);
      }
      if (addAnggotaForm["bps"] instanceof File) {
        data.append("bps", addAnggotaForm["bps"]);
      }
      if (addAnggotaForm["lainnya"] instanceof File) {
        data.append("lainnya", addAnggotaForm["lainnya"]);
      }

      const validateData = formValidator(data, 'pencipta', isEdit, addAnggotaForm.documents)
      // console.log('lalawww', addAnggotaForm.documents)
      if (!validateData) return

      if (isEdit) {
        Swal.fire({
          icon: "question",
          title: "Edit data",
          text: "Apakah anda yakin data anda sudah benar?",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          showConfirmButton: true,
          confirmButtonText: "Ya",
          confirmButtonColor: "#4dbd74",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await API_PUT_MAMBOO.update
              .updatePenciptaByIdUser(detailPencipta.user_id, data)
              .then((response) => {
                Swal.fire("Data berhasil diperbarui", "", "success").then(
                  (result) => {
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  }
                );
              })
              .catch((err) => {
                Swal.fire("Data gagal diperbarui", "", "error");
              });
          } else {
            Swal.fire("Data batal diperbarui", "", "info");
          }
        });
      } else {
        Swal.fire({
          icon: "question",
          title: "Daftar Songwriter",
          text: "Apakah anda yakin data anda sudah benar?",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          showConfirmButton: true,
          confirmButtonText: "Ya",
          confirmButtonColor: "#4dbd74",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await API_POST_MAMBOO.actions
              .savePenciptaLagu(data)
              .then((response) => {
                Swal.fire("Data berhasil di simpan", "", "success").then(
                  (result) => {
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  }
                );
              })
              .catch((err) => {
                Swal.fire("Data gagal diperbarui", "", "error");
              });
          } else {
            Swal.fire("Data batal disimpan", "", "info");
          }
        });
      }

    } else {
      if (isEdit) {
        payload = {
          creator_ref: detailPencipta.ahli_waris.creator_ref,
          name: addAhliWarisForm.name_ahli_waris,
          role_code: String(isValueRole.value),
          email: addAhliWarisForm.email_ahli_waris,
          password: addAhliWarisForm.date_of_birth_ahli_waris,
          address: addAhliWarisForm.address_ahli_waris,
          phone_number: addAhliWarisForm.phone_number_ahli_waris,
          place_of_birth: addAhliWarisForm.place_of_birth_ahli_waris,
          date_of_birth: addAhliWarisForm.date_of_birth_ahli_waris,
          identity_number: keepOnlyNumbers(addAhliWarisForm.identity_number_ahli_waris),
          npwp_number: keepOnlyNumbers(addAhliWarisForm.npwp_ahli_waris),
          bank_data: {
            bank: addAhliWarisForm.bank_ahli_waris.value,
            account_name: addAhliWarisForm.account_name_ahli_waris,
            account_number: addAhliWarisForm.account_number_ahli_waris
          }
        }
      } else {
        payload = {
          pencipta: {
            user_id: !isEnabledCheckbox ? isPencipta.value : null,
            name: addAhliWarisForm.name_pencipta,
            role_code: "3",
            ip_base_number: addAhliWarisForm.ip_base_number_pencipta,
            address: addAhliWarisForm.address_pencipta,
            phone_number: addAhliWarisForm.phone_number_pencipta,
            place_of_birth: addAhliWarisForm.place_of_birth_pencipta,
            date_of_birth: addAhliWarisForm.date_of_birth_pencipta,
            dates_of_death: addAhliWarisForm.date_of_death_pencipta,
            identity_number: keepOnlyNumbers(addAhliWarisForm.identity_number_pencipta),
            popular_name: namaPopuler
          },
          ahli_waris: {
            name: addAhliWarisForm.name_ahli_waris,
            role_code: String(isValueRole.value),
            email: addAhliWarisForm.email_ahli_waris,
            password: addAhliWarisForm.date_of_birth_ahli_waris,
            address: addAhliWarisForm.address_ahli_waris,
            phone_number: addAhliWarisForm.phone_number_ahli_waris,
            place_of_birth: addAhliWarisForm.place_of_birth_ahli_waris,
            date_of_birth: addAhliWarisForm.date_of_birth_ahli_waris,
            identity_number: keepOnlyNumbers(addAhliWarisForm.identity_number_ahli_waris),
            npwp_number: keepOnlyNumbers(addAhliWarisForm.npwp_ahli_waris),
            bank_data: {
              bank: addAhliWarisForm.bank_ahli_waris.value,
              account_name: addAhliWarisForm.account_name_ahli_waris,
              account_number: addAhliWarisForm.account_number_ahli_waris
            }
          }
        }
      }

      data.append("payload", JSON.stringify(payload));
      if (addAhliWarisForm["ktp"] instanceof File) {
        data.append("ktp", addAhliWarisForm["ktp"]);
      }
      if (addAhliWarisForm["npwp"] instanceof File) {
        data.append("npwp", addAhliWarisForm["npwp"]);
      }
      if (addAhliWarisForm["bps"] instanceof File) {
        data.append("bps", addAhliWarisForm["bps"]);
      }
      if (addAhliWarisForm["ahli_waris"] instanceof File) {
        data.append("ahli_waris", addAhliWarisForm["ahli_waris"]);
      }
      if (addAhliWarisForm["lainnya"] instanceof File) {
        data.append("lainnya", addAhliWarisForm["lainnya"]);
      }


      // const validateData = formValidator(data, 'ahli waris')
      // if (!validateData) return

      if (isEdit) {
        Swal.fire({
          icon: "question",
          title: "Edit data",
          text: "Apakah anda yakin data anda sudah benar?",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          showConfirmButton: true,
          confirmButtonText: "Ya",
          confirmButtonColor: "#4dbd74",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await API_PUT_MAMBOO.update
              .updateAhliWaris(detailPencipta.ahli_waris.user_id, data)
              .then((response) => {
                Swal.fire("Data berhasil diperbarui", "", "success").then(
                  (result) => {
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  }
                );
              })
              .catch((err) => {
                Swal.fire("Data gagal diperbarui", "", "error");
              });
          } else {
            Swal.fire("Data batal diperbarui", "", "info");
          }
        });
      } else {
        Swal.fire({
          icon: "question",
          title: "Daftar Ahli Waris",
          text: "Apakah anda yakin data anda sudah benar?",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          showConfirmButton: true,
          confirmButtonText: "Ya",
          confirmButtonColor: "#4dbd74",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await API_POST_MAMBOO.actions
              .saveAhliWaris(data)
              .then((response) => {
                Swal.fire("Data berhasil di simpan", "", "success").then(
                  (result) => {
                    if (result.isConfirmed) {
                      window.location.reload();
                    }
                  }
                );
              })
              .catch((err) => {
                Swal.fire("Data gagal di simpan", "", "error");
              });
          } else {
            Swal.fire("Data batal di simpan", "", "info");
          }
        });
      }
    }
  };

  const onCreateOption = async (index, newOption) => {
    await setPencipta((prev) => ([...prev, { label: newOption, value: newOption, id: newOption }]))
    onChangeSelectPencipta({ label: newOption, value: newOption, id: newOption })
  }

  const getByRole = async (keyword = '') => {
    await API_GET_MAMBOO.dynamic.getByRole(3, keyword, true, true)
    .then((res) => {
      setPencipta(res.map((val) => ({ label: val.name, value: val.name, id: val.creator_id })))
    })
  }

  const onChangeSelectPencipta = (e) => {
    setAddAnggotaForm((prev) => ({...prev, name: e.value}))
  }

  useEffect(() => {
    getByRole()
    API_GET_MAMBOO.dynamic.getRole().then((data) => {
      const isFilterRole = [];
      for (const item of data) {
        if (item.role === "Ahli Waris" || item.role === "Pencipta Lagu") {
          isFilterRole.push(item);
        }
      }

      const isFixedRole = isFilterRole.map(({ role, role_code }) => {
        return {
          label: role,
          value: role_code,
        };
      });

      setIsRole(isFixedRole);
    });

    API_GET_MAMBOO.dynamic
      .getListBank()
      .then((data) => {
        const isListBank = data.map(({ ur_bank }) => {
          return {
            label: ur_bank,
            value: ur_bank,
          };
        });
        setListBank(isListBank);
      })
      .catch(() => {
        setListBank([]);
      });
  }, []);

  useEffect(() => {
    if (isValueRole.value === 7) {
      fetchingListRole();
    }
    handleFileChoose();
  }, [isValueRole]);

  useEffect(() => {
    if (
      !isEnabledCheckbox &&
      isValueRole.value === 7 &&
      isPencipta &&
      isPencipta.value
    ) {
      API_GET_MAMBOO.dynamic
        .getPenciptaByUserId(isPencipta.value)
        .then((data) => {
          setAddAhliWarisForm({
            ...addAhliWarisForm,
            name_pencipta: data.name,
            ip_base_number_pencipta: data.ip_base_number,
            popular_name_pencipta: data.popular_name,
            address_pencipta: data.address,
            phone_number_pencipta: data.phone_number,
            place_of_birth_pencipta: data.place_of_birth,
            date_of_birth_pencipta: toDisplayDate(data.date_of_birth),
            date_of_death_pencipta: toDisplayDate(data.dates_of_death),
            identity_number_pencipta: data.identity_number,
          })
        });
    }

  }, [isPencipta]);

  useEffect(() => {
    const npwpPencipta = keepOnlyNumbers(addAnggotaForm.npwp_number)
    const npwpAhliWaris = keepOnlyNumbers(addAhliWarisForm.npwp_ahli_waris)
    const ktpAhliWaris = keepOnlyNumbers(addAhliWarisForm.identity_number_ahli_waris)
    const ktpPenciptaAsAhliWaris = keepOnlyNumbers(addAhliWarisForm.identity_number_pencipta)
    const ktpPencipta = keepOnlyNumbers(addAnggotaForm.identity_number)
    if(((npwpPencipta.length == 15 || npwpPencipta.length == 16) && ktpPencipta.length === 16) || ((npwpAhliWaris.length == 15 || npwpAhliWaris.length == 16) && ktpAhliWaris.length === 16 && ktpPenciptaAsAhliWaris.length === 16)) {
      setIsDisable(false)
    } else {
      setIsDisable(true)
    }

    // Validasi Npwp dan KTP Pencipta
    if(npwpPencipta.length == 15 || npwpPencipta.length == 16) {
      setValidasiNpwpPencipta(false)
    } else {
      setValidasiNpwpPencipta(true)
    }

    if(ktpPencipta.length == 16) {
      setValidasiKtpPencipta(false)
    } else {
      setValidasiKtpPencipta(true)
    }

    // Validasi Npwp dan KTP Ahli Waris
    if(npwpAhliWaris.length == 15 || npwpAhliWaris.length == 16) {
      setValidasiNpwpAhliWaris(false)
    } else {
      setValidasiNpwpAhliWaris(true)
    }

    if(ktpAhliWaris.length == 16) {
      setValidasiKtpAhliWaris(false)
    } else {
      setValidasiKtpAhliWaris(true)
    }

    if(ktpPenciptaAsAhliWaris && ktpPenciptaAsAhliWaris.length == 16) {
      setValidasiKtpPenciptaAsAhliWaris(false)
    } else {
      setValidasiKtpPenciptaAsAhliWaris(true)
    }
  },[addAnggotaForm.npwp_number, addAhliWarisForm.npwp_ahli_waris, addAnggotaForm.identity_number, addAhliWarisForm.identity_number_ahli_waris, addAhliWarisForm.identity_number_pencipta, isDisable])

  useEffect(() => {
    if(!isEdit) {
      if(isValueRole.value === 3) {
        setAddAnggotaForm({
          name: "",
          ip_base_number: "I-",
          popular_name: "",
          ip_name_number: "",
          email: "",
          address: "",
          phone_number: "",
          place_of_birth: "",
          date_of_birth: "",
          identity_number: "",
          npwp_number: "",
          bps_number: "",
          bank: "",
          account_name: "",
          account_number: "",
          documents: [],
        })
      } else {
        setIsPencipta({
          label: null,
          value: null
        })
        setAddAhliWarisForm({
          name_pencipta: "",
          ip_base_number_pencipta: "I-",
          popular_name_pencipta: "",
          address_pencipta: "",
          phone_number_pencipta: "",
          place_of_birth_pencipta: "",
          date_of_birth_pencipta: "",
          date_of_death_pencipta: "",
          identity_number_pencipta: "",
          name_ahli_waris: "",
          email_ahli_waris: "",
          address_ahli_waris: "",
          phone_number_ahli_waris: "",
          place_of_birth_ahli_waris: "",
          date_of_birth_ahli_waris: "",
          identity_number_ahli_waris: "",
          npwp_ahli_waris: "",
          bank_ahli_waris: "",
          account_name_ahli_waris: "",
          account_number_ahli_waris: "",
          documents: []
        })
      }
    }
  }, [isValueRole])

  return (
    <>
      {/* {console.log("llllll", { detailPencipta, addAnggotaForm })} */}
      {/* {console.log(isFileChoose)} */}
      {console.log({addAhliWarisForm})}
      <Container className="content-pencipta">
        <div className="header-content">
          <div className="pencipta-header">
            <h1>Registrasi Songwriter</h1>
          </div>
          <div className="icon-wrapper">
            <Bell />
          </div>
        </div>
        <div className="tabs-filters">
          <div className="frame-filters">
            <CustomButton
              label="Kembali"
              size="md"
              iconPosition="left"
              LabelIcon={FiArrowLeft}
              className="button-kembali"
              onClick={handleBack}
            />
          </div>
        </div>
        {(isValueRole && isValueRole.value === 3) || !isValueRole.value ? (
          <>
            {/******************** Scope Informasi Umum dan Informasi Lainnya on role pencipta ********************/}
            <div className="scope-container">
              {/************************ Start Informasi Umum on role pencipta *********************/}
              <div className="frame" style={{ width: "50%", height: "788px" }}>
                <div className="text-informasi">Informasi Umum</div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Registrasi Sebagai
                  </div>
                  <FormSelects
                    placeholder="Pencipta / Ahli Waris"
                    styles={customStyles}
                    options={isRole}
                    onChange={onChangeSelect}
                    value={isValueRole.value}
                    isDisabled={isReadOnly}
                    // defaultValue={isValueRole}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Nama Lengkap
                    Pencipta (Sesuai KTP)
                  </div>
                  {pencipta.length > 0 ? (
                    <FormCreatableSelects
                      placeholder="Isi nama lengkap"
                      formatCreateLabel={(string) => `Buat '${string}'`}
                      onCreateOption={(string) => onCreateOption(-1, string)}
                      name="name"
                      options={pencipta}
                      // isDisabled={true}
                      value={addAnggotaForm.name}
                      onChange={(val) => onChangeSelectPencipta(val)}
                      styles={customStylesNama}
                      isDisabled={isFieldDisabled}
                    />
                  ) : (
                    <FormInputs
                      placeholder="Isi nama lengkap"
                      className="frame-wrapper"
                      name="name"
                      onChange={onChange}
                      value={addAnggotaForm.name}
                      isDisabled={isFieldDisabled}
                    />
                  )}
                </div>
                <div className="content-email">
                  <div className="text-input">IP Base Number</div>
                  <div style={{ display: 'flex', width: '100%', border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden', background: isFieldDisabled ? 'var(--surface-2)' : 'var(--surface-1)' }}>
                    <span style={{ background: 'var(--border-strong)', padding: '16px 14px', color: 'var(--text-secondary)', borderRight: '1px solid var(--border)', fontWeight: '600', fontSize: '14px', display: 'flex', alignItems: 'center', userSelect: 'none' }}>I-</span>
                    <input
                      name="ip_base_number"
                      value={addAnggotaForm.ip_base_number.startsWith('I-') ? addAnggotaForm.ip_base_number.slice(2) : addAnggotaForm.ip_base_number}
                      onChange={onChange}
                      placeholder="000000000-0"
                      disabled={isFieldDisabled}
                      style={{ border: 'none', outline: 'none', flex: 1, padding: '16px 14px', fontSize: '14px', background: 'transparent' }}
                    />
                  </div>
                </div>
                <div className="content-input">
                  <div className="subcontent-input">
                    <div className="text-input">Nama Populer</div>
                    <FormInputs
                      placeholder="Isi nama populer"
                      className="frame-wrapper"
                      name="popular_name"
                      onChange={onChange}
                      value={addAnggotaForm.popular_name}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <div className="subcontent-input">
                    <div className="text-input">IP Name Number</div>
                    <FormInputs
                      placeholder="Isi IP Name"
                      className="frame-wrapper"
                      name="ip_name_number"
                      onChange={onChange}
                      value={addAnggotaForm.ip_name_number}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <CustomButton
                    label="Add"
                    color={"primary-btn"}
                    className="btn-add"
                    onClick={actionRolePencipta}
                    disabled={isFieldDisabled}
                  />
                </div>
                <div
                  style={{
                    display:
                      namaPopulerWithIpNumber.length > 0 ? "flex" : "none",
                  }}
                  className="judul-lain-wrapper"
                >
                  {namaPopulerWithIpNumber.map((value, index) =>
                    namaPopulerWithIpNumberComponent(value, index)
                  )}
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Email
                  </div>
                  <FormInputs
                    placeholder="email@email.com"
                    className="frame-wrapper"
                    name="email"
                    onChange={onChange}
                    value={addAnggotaForm.email}
                    isDisabled={isFieldDisabled}
                  />
                </div>
              </div>
              {/************************ Start Informasi Lainnya on role Pencipta  *********************/}
              <div className="frame" style={{ width: "50%" }}>
                <div className="text-informasi">Informasi Lainnya</div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Alamat Rumah
                  </div>
                  <FormInputs
                    placeholder="Masukan alamat sesuai ktp"
                    className="frame-wrapper"
                    name="address"
                    onChange={onChange}
                    value={addAnggotaForm.address}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Telepon/HP
                  </div>
                  <FormInputs
                    placeholder="Masukkan nomor telepon"
                    className="frame-wrapper"
                    name="phone_number"
                    onChange={onChange}
                    value={addAnggotaForm.phone_number}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-input">
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tempat Lahir
                    </div>
                    <FormInputs
                      placeholder="Masukkan Tempat lahir"
                      className="frame-wrapper"
                      name="place_of_birth"
                      onChange={onChange}
                      value={addAnggotaForm.place_of_birth}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tanggal Lahir
                    </div>
                    <ReactDatePicker
                      className="frame-wrapper"
                      name="date_of_birth"
                      selected={fromDisplayDate(addAnggotaForm.date_of_birth)}
                      value={addAnggotaForm.date_of_birth}
                      onChange={(date) =>
                        handleDateChange(date, "date_of_birth")
                      }
                      showYearDropdown
                      showMonthDropdown
                      dateFormat={DATE_PICKER_FORMAT}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showIcon={true}
                      placeholderText={DATE_PLACEHOLDER}
                      customInput={<CustomInputDate />}
                      disabled={isFieldDisabled}
                    />
                  </div>
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>No Identitas KTP
                  </div>
                  <FormInputs
                    placeholder="Masukkan no KTP"
                    className="frame-wrapper"
                    name="identity_number"
                    onChange={onChange}
                    value={addAnggotaForm.identity_number}
                    isDisabled={isFieldDisabled}
                  />
                  {validasiKtpPencipta && (
                    <small style={{ color: "red" }}>
                      * Pastikan panjang karakter KTP 16 digit
                    </small>
                  )}
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>No NPWP
                  </div>
                  <FormInputs
                    placeholder="Masukkan No NPWP"
                    className="frame-wrapper"
                    name="npwp_number"
                    onChange={onChange}
                    value={addAnggotaForm.npwp_number}
                    isDisabled={isFieldDisabled}
                  />
                  {validasiNpwpPencipta && (
                    <small style={{ color: "red" }}>
                      * Pastikan panjang karakter NPWP 15/16 digit
                    </small>
                  )}
                </div>
                <div className="content-email">
                  <div className="text-input">No BPS</div>
                  <FormInputs
                    placeholder="Masukkan No BPS"
                    className="frame-wrapper"
                    name="bps_number"
                    onChange={onChange}
                    value={addAnggotaForm.bps_number}
                    isDisabled={isFieldDisabled}
                  />
                </div>
              </div>
            </div>

            {/******************** Scope Data Bank dan Upload Dokumen on role pencipta ********************/}
            <div className="scope-container">
              {/************************ Start Data Bank on role pencipta *********************/}
              <div
                className="frame"
                style={{ width: "50%", margin: "0", height: "471px" }}
              >
                <div className="text-informasi">Data Bank</div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Nama Bank
                  </div>
                  <FormSelects
                    className="frame-wrapper"
                    placeholder="Pilih Nama Bank"
                    styles={customStyles}
                    options={listBank}
                    onChange={(Value) => {
                      setAddAnggotaForm({ ...addAnggotaForm, bank: Value });
                    }}
                    value={addAnggotaForm.bank}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>
                    No Rekening
                  </div>
                  <FormInputs
                    placeholder="Masukkan no rekening"
                    className="frame-wrapper"
                    name="account_number"
                    onChange={onChange}
                    value={addAnggotaForm.account_number}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>
                    Atas Nama
                  </div>
                  <FormInputs
                    placeholder="Nama pemilik no rekening"
                    className="frame-wrapper"
                    name="account_name"
                    onChange={onChange}
                    value={addAnggotaForm.account_name}
                    isDisabled={isFieldDisabled}
                  />
                </div>
              </div>
              {/************************ Start Upload Dokumen on role Pencipta  *********************/}
              <div className="upload-dokumen">
                <div className="sub-upload-dokumen">
                  <div className="frame-sub-upload">
                    <div className="frame-sub-upload-2">
                      <div className="text-verifikasi-publisher">
                        Upload Dokumen
                      </div>
                      <p className="text-upload-format">
                        Upload dengan format : JPEG, PNG, atau PDF
                      </p>
                    </div>
                    <div className="frame-upload-dokumen">
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              <span style={{ color: "red" }}>* </span>Foto KTP
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.ktp
                                        ? filePreviewUrl.ktp.data
                                        : isFileChoose?.ktp?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.ktp
                                  ? filePreviewUrl.ktp.name
                                  : isFileChoose.ktp && isFileChoose.ktp?.label
                                  ? isFileChoose.ktp?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="ktp"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("ktp")}
                              disabled={isFieldDisabled}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              <span style={{ color: "red" }}>* </span>Foto NPWP
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.npwp
                                        ? filePreviewUrl.npwp.data
                                        : isFileChoose.npwp &&
                                          isFileChoose.npwp?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.npwp
                                  ? filePreviewUrl.npwp.name
                                  : isFileChoose.npwp &&
                                    isFileChoose.npwp?.label
                                  ? isFileChoose.npwp?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="npwp"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("npwp")}
                              disabled={isFieldDisabled}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">Dokumen BPS</div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.bps
                                        ? filePreviewUrl.bps.data
                                        : isFileChoose.bps &&
                                          isFileChoose.bps?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.bps
                                  ? filePreviewUrl.bps.name
                                  : isFileChoose.bps && isFileChoose.bps?.label
                                  ? isFileChoose.bps?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="bps"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("bps")}
                              disabled={isFieldDisabled}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              Dokumen Lainnya
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.lainnya
                                        ? filePreviewUrl.lainnya.data
                                        : isFileChoose.lainnya &&
                                          isFileChoose.lainnya?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.lainnya
                                  ? filePreviewUrl.lainnya.name
                                  : isFileChoose.lainnya &&
                                    isFileChoose.lainnya?.label
                                  ? isFileChoose.lainnya?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="lainnya"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("lainnya")}
                              disabled={isFieldDisabled}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/******************** Scope Informasi Umum dan Informasi Lainnya on role Ahli Waris ********************/}
            <div className="scope-container">
              {/************************ Start Informasi Umum on role Ahli Waris *********************/}
              <div className="frame" style={{ width: "50%" }}>
                <div className="text-informasi">Informasi Umum</div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Registrasi Sebagai
                  </div>
                  <FormSelects
                    placeholder="Pencipta / Ahli Waris"
                    styles={customStyles}
                    options={isRole}
                    onChange={onChangeSelect}
                    value={isValueRole.value}
                    // defaultValue={isValueRole}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <Row
                    style={{ width: "100%", justifyContent: "space-between" }}
                  >
                    <div
                      className="text-input"
                      style={{ width: "fit-content" }}
                    >
                      <span style={{ color: "red" }}>* </span>Nama Lengkap
                      Pencipta (Sesuai KTP)
                    </div>
                    <FormGroup
                      check
                      inline
                      style={{
                        width: "fit-content",
                        marginRight: "0px",
                        paddingRight: "0px",
                      }}
                    >
                      <Input
                        type="checkbox"
                        onChange={onChangeCheckbox}
                        value={isEnabledCheckbox}
                        defaultChecked={isEnabledCheckbox}
                        disabled={isFieldDisabled}
                      />
                      <Label check style={{ fontWeight: "bolder" }}>
                        Add Pencipta
                      </Label>
                    </FormGroup>
                  </Row>
                  {isEnabledCheckbox ? (
                    <FormInputs
                      placeholder="Isi nama lengkap"
                      className="frame-wrapper"
                      name="name_pencipta"
                      onChange={onChange}
                      value={addAhliWarisForm.name_pencipta}
                      isDisabled={isFieldDisabled}
                    />
                  ) : (
                    <FormSelects
                      placeholder="Pilih Songwriter"
                      styles={customStyles}
                      options={isOptionsPencipta}
                      onChange={onChangeIsPencipta}
                      value={isPencipta.value}
                      isDisabled={isFieldDisabled}
                    />
                  )}
                </div>
                <div className="content-email">
                  <div className="text-input">IP Base Number</div>
                  <div style={{ display: 'flex', width: '100%', border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden', background: isFieldDisabled ? 'var(--surface-2)' : 'var(--surface-1)' }}>
                    <span style={{ background: 'var(--border-strong)', padding: '16px 14px', color: 'var(--text-secondary)', borderRight: '1px solid var(--border)', fontWeight: '600', fontSize: '14px', display: 'flex', alignItems: 'center', userSelect: 'none' }}>I-</span>
                    <input
                      name="ip_base_number_pencipta"
                      value={addAhliWarisForm.ip_base_number_pencipta.startsWith('I-') ? addAhliWarisForm.ip_base_number_pencipta.slice(2) : addAhliWarisForm.ip_base_number_pencipta}
                      onChange={onChange}
                      placeholder="000000000-0"
                      disabled={isFieldDisabled}
                      style={{ border: 'none', outline: 'none', flex: 1, padding: '16px 14px', fontSize: '14px', background: 'transparent' }}
                    />
                  </div>
                </div>
                <div className="content-input">
                  <div className="subcontent-input">
                    <div className="text-input">Nama Populer</div>
                    <FormInputs
                      placeholder="Isi nama populer"
                      className="frame-wrapper"
                      name="popular_name_pencipta"
                      onChange={onChange}
                      value={addAhliWarisForm.popular_name_pencipta}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <CustomButton
                    label="Add"
                    color={"primary-btn"}
                    className="btn-add"
                    disabled={isFieldDisabled}
                    onClick={actionRolePencipta}
                  />
                </div>
                <div
                  style={{
                    display: namaPopuler.length > 0 ? "flex" : "none",
                  }}
                  className="judul-lain-wrapper"
                >
                  {namaPopuler.map((value, index) =>
                    namaPopulerWithIpNumberComponent(value, index)
                  )}
                </div>
              </div>
              {/************************ Start Informasi Lainnya on role Ahli Waris  *********************/}
              <div className="frame" style={{ width: "50%" }}>
                <div className="text-informasi">Informasi Lainnya</div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Alamat Rumah
                  </div>
                  <FormInputs
                    placeholder="Masukan alamat sesuai ktp"
                    className="frame-wrapper"
                    name="address_pencipta"
                    onChange={onChange}
                    value={addAhliWarisForm.address_pencipta}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Telepon/HP
                  </div>
                  <FormInputs
                    placeholder="Masukkan No telepon"
                    className="frame-wrapper"
                    name="phone_number_pencipta"
                    onChange={onChange}
                    value={addAhliWarisForm.phone_number_pencipta}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-input">
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tempat Lahir
                    </div>
                    <FormInputs
                      placeholder="Masukkan tempat lahir"
                      className="frame-wrapper"
                      name="place_of_birth_pencipta"
                      onChange={onChange}
                      value={addAhliWarisForm.place_of_birth_pencipta}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tanggal Lahir
                    </div>
                    <ReactDatePicker
                      className="frame-wrapper"
                      name="date_of_birth_pencipta"
                      selected={fromDisplayDate(addAhliWarisForm.date_of_birth_pencipta)}
                      value={addAhliWarisForm.date_of_birth_pencipta}
                      onChange={(date) =>
                        handleDateChange(date, "date_of_birth_pencipta")
                      }
                      showYearDropdown
                      showMonthDropdown
                      dateFormat={DATE_PICKER_FORMAT}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showIcon={true}
                      placeholderText={DATE_PLACEHOLDER}
                      customInput={<CustomInputDate />}
                      disabled={isFieldDisabled}
                    />
                  </div>
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tanggal Wafat
                    </div>
                    <ReactDatePicker
                      className="frame-wrapper"
                      name="date_of_death_pencipta"
                      selected={fromDisplayDate(addAhliWarisForm.date_of_death_pencipta)}
                      value={addAhliWarisForm.date_of_death_pencipta}
                      onChange={(date) =>
                        handleDateChange(date, "date_of_death_pencipta")
                      }
                      showYearDropdown
                      showMonthDropdown
                      dateFormat={DATE_PICKER_FORMAT}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showIcon={true}
                      placeholderText={DATE_PLACEHOLDER}
                      customInput={<CustomInputDate />}
                      disabled={isFieldDisabled}
                    />
                  </div>
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>No Identitas KTP
                  </div>
                  <FormInputs
                    placeholder="Masukkan No identitas"
                    className="frame-wrapper"
                    name="identity_number_pencipta"
                    onChange={onChange}
                    value={addAhliWarisForm.identity_number_pencipta}
                    isDisabled={isFieldDisabled}
                  />
                  {validasiKtpPenciptaAsAhliWaris && (
                    <small style={{ color: "red" }}>
                      * Pastikan panjang karakter KTP 16 digit
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="scope-container">
              {/************************ Start Informasi Ahli Waris on role Ahli Waris  *********************/}
              <div
                className="frame"
                style={{ width: "50%", margin: "0", minHeight: "1024px" }}
              >
                <div className="text-informasi">Informasi Ahli Waris</div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Nama Ahli Waris
                    (Sesuai KTP)
                  </div>
                  <FormInputs
                    placeholder="Masukkan nama ahli waris"
                    className="frame-wrapper"
                    name="name_ahli_waris"
                    onChange={onChange}
                    value={addAhliWarisForm.name_ahli_waris}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Email
                  </div>
                  <FormInputs
                    placeholder="Masukkan email"
                    className="frame-wrapper"
                    name="email_ahli_waris"
                    onChange={onChange}
                    value={addAhliWarisForm.email_ahli_waris}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Alamat Rumah
                  </div>
                  <FormInputs
                    placeholder="Masukan alamat sesuai ktp"
                    className="frame-wrapper"
                    name="address_ahli_waris"
                    onChange={onChange}
                    value={addAhliWarisForm.address_ahli_waris}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>Telepon/HP
                  </div>
                  <FormInputs
                    placeholder="Masukkan No Telepon"
                    className="frame-wrapper"
                    name="phone_number_ahli_waris"
                    onChange={onChange}
                    value={addAhliWarisForm.phone_number_ahli_waris}
                    isDisabled={isFieldDisabled}
                  />
                </div>
                <div className="content-input">
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tempat Lahir
                    </div>
                    <FormInputs
                      placeholder="Tempat lahir"
                      className="frame-wrapper"
                      name="place_of_birth_ahli_waris"
                      onChange={onChange}
                      value={addAhliWarisForm.place_of_birth_ahli_waris}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <div className="subcontent-input">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Tanggal Lahir
                    </div>
                    <ReactDatePicker
                      className="frame-wrapper"
                      name="date_of_birth_ahli_waris"
                      selected={fromDisplayDate(addAhliWarisForm.date_of_birth_ahli_waris)}
                      value={addAhliWarisForm.date_of_birth_ahli_waris}
                      onChange={(date) =>
                        handleDateChange(date, "date_of_birth_ahli_waris")
                      }
                      showYearDropdown
                      showMonthDropdown
                      dateFormat={DATE_PICKER_FORMAT}
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown={true}
                      showIcon={true}
                      placeholderText={DATE_PLACEHOLDER}
                      customInput={<CustomInputDate />}
                      disabled={isFieldDisabled}
                    />
                  </div>
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>No Identitas KTP
                    (Ahli Waris)
                  </div>
                  <FormInputs
                    placeholder="Masukkan No identitas"
                    className="frame-wrapper"
                    name="identity_number_ahli_waris"
                    onChange={onChange}
                    value={addAhliWarisForm.identity_number_ahli_waris}
                    isDisabled={isFieldDisabled}
                  />
                  {validasiKtpAhliWaris && (
                    <small style={{ color: "red" }}>
                      * Pastikan panjang karakter KTP 16 digit
                    </small>
                  )}
                </div>
                <div className="content-email">
                  <div className="text-input">
                    <span style={{ color: "red" }}>* </span>No NPWP (Ahli Waris)
                  </div>
                  <FormInputs
                    placeholder="Masukkan No NPWP"
                    className="frame-wrapper"
                    name="npwp_ahli_waris"
                    onChange={onChange}
                    value={addAhliWarisForm.npwp_ahli_waris}
                    isDisabled={isFieldDisabled}
                  />
                  {validasiNpwpAhliwaris && (
                    <small style={{ color: "red" }}>
                      * Pastikan panjang karakter NPWP 15/16 digit
                    </small>
                  )}
                </div>
              </div>

              {/******************** Scope Data Bank dan Upload Dokumen on role Ahli Waris ********************/}
              <div className="scope-sub-container">
                {/************************ Start Data Bank on role Ahli Waris *********************/}
                <div className="frame" style={{ width: "100%", margin: "0" }}>
                  <div className="text-informasi">Data Bank</div>
                  <div className="content-email">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>Nama Bank
                    </div>
                    <FormSelects
                      className="frame-wrapper"
                      placeholder="Pilih Nama Bank"
                      styles={customStyles}
                      options={listBank}
                      onChange={(Value) => {
                        setAddAhliWarisForm({
                          ...addAhliWarisForm,
                          bank_ahli_waris: Value,
                        });
                      }}
                      value={addAhliWarisForm.bank_ahli_waris}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <div className="content-email">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      No Rekening
                    </div>
                    <FormInputs
                      placeholder="Isi No rekening"
                      className="frame-wrapper"
                      name="account_number_ahli_waris"
                      onChange={onChange}
                      value={addAhliWarisForm.account_number_ahli_waris}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                  <div className="content-email">
                    <div className="text-input">
                      <span style={{ color: "red" }}>* </span>
                      Atas Nama
                    </div>
                    <FormInputs
                      placeholder="Nama pemilik no rekening"
                      className="frame-wrapper"
                      name="account_name_ahli_waris"
                      onChange={onChange}
                      value={addAhliWarisForm.account_name_ahli_waris}
                      isDisabled={isFieldDisabled}
                    />
                  </div>
                </div>
                {/************************ Start Upload Dokumen on role Ahli Waris  *********************/}
                <div className="upload-dokumen">
                  <div className="sub-upload-dokumen">
                    <div className="frame-sub-upload">
                      <div className="frame-sub-upload-2">
                        <div className="text-verifikasi-publisher">
                          Upload Dokumen
                        </div>
                        <p className="text-upload-format">
                          Upload dengan format : JPEG, PNG, atau PDF
                        </p>
                      </div>
                      <div className="frame-upload-dokumen">
                        <div className="frame-sub-upload-dokumen">
                          <div className="frame-izin-usaha">
                            <div className="frame-sub-izin-usaha">
                              <div className="text-izin-usaha">
                                <span style={{ color: "red" }}>* </span>Foto KTP
                              </div>
                            </div>
                            <div className="frame-file-izin-usaha">
                              <div className="frame-sub-file-izin-usaha">
                                <div
                                  className="text-file"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    window.open(
                                      `${
                                        filePreviewUrl && filePreviewUrl?.ktp
                                          ? filePreviewUrl.ktp.data
                                          : isFileChoose?.ktp?.link
                                      }`
                                    );
                                  }}
                                >
                                  {filePreviewUrl && filePreviewUrl?.ktp
                                    ? filePreviewUrl.ktp.name
                                    : isFileChoose.ktp &&
                                      isFileChoose.ktp?.label
                                    ? isFileChoose.ktp?.label
                                    : "No File Choose"}
                                </div>
                              </div>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  handleFileChange(e);
                                }}
                                ref={fileInputRef}
                                accept=".jpg,.jpeg,.png,.pdf"
                                name="ktp"
                              />
                              <CustomButton
                                label="Upload File"
                                color="primary-btn"
                                className="button-file"
                                ukuran="btn-sm"
                                onClick={() => handleButtonClick("ktp")}
                                disabled={isFieldDisabled}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="frame-sub-upload-dokumen">
                          <div className="frame-izin-usaha">
                            <div className="frame-sub-izin-usaha">
                              <div className="text-izin-usaha">
                                <span style={{ color: "red" }}>* </span>Foto
                                NPWP
                              </div>
                            </div>
                            <div className="frame-file-izin-usaha">
                              <div className="frame-sub-file-izin-usaha">
                                <div
                                  className="text-file"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    window.open(
                                      `${
                                        filePreviewUrl && filePreviewUrl?.npwp
                                          ? filePreviewUrl.npwp.data
                                          : isFileChoose.npwp &&
                                            isFileChoose.npwp?.link
                                      }`
                                    );
                                  }}
                                >
                                  {filePreviewUrl && filePreviewUrl?.npwp
                                    ? filePreviewUrl.npwp.name
                                    : isFileChoose.npwp &&
                                      isFileChoose.npwp?.label
                                    ? isFileChoose.npwp?.label
                                    : "No File Choose"}
                                </div>
                              </div>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  handleFileChange(e);
                                }}
                                ref={fileInputRef}
                                accept=".jpg,.jpeg,.png,.pdf"
                                name="npwp"
                              />
                              <CustomButton
                                label="Upload File"
                                color="primary-btn"
                                className="button-file"
                                ukuran="btn-sm"
                                onClick={() => handleButtonClick("npwp")}
                                disabled={isFieldDisabled}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="frame-sub-upload-dokumen">
                          <div className="frame-izin-usaha">
                            <div className="frame-sub-izin-usaha">
                              <div className="text-izin-usaha">Dokumen BPS</div>
                            </div>
                            <div className="frame-file-izin-usaha">
                              <div className="frame-sub-file-izin-usaha">
                                <div
                                  className="text-file"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    window.open(
                                      `${
                                        filePreviewUrl && filePreviewUrl?.bps
                                          ? filePreviewUrl.bps.data
                                          : isFileChoose.bps &&
                                            isFileChoose.bps?.link
                                      }`
                                    );
                                  }}
                                >
                                  {filePreviewUrl && filePreviewUrl?.bps
                                    ? filePreviewUrl.bps.name
                                    : isFileChoose.bps &&
                                      isFileChoose.bps?.label
                                    ? isFileChoose.bps?.label
                                    : "No File Choose"}
                                </div>
                              </div>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  handleFileChange(e);
                                }}
                                ref={fileInputRef}
                                accept=".jpg,.jpeg,.png,.pdf"
                                name="bps"
                              />
                              <CustomButton
                                label="Upload File"
                                color="primary-btn"
                                className="button-file"
                                ukuran="btn-sm"
                                onClick={() => handleButtonClick("bps")}
                                disabled={isFieldDisabled}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="frame-sub-upload-dokumen">
                          <div className="frame-izin-usaha">
                            <div className="frame-sub-izin-usaha">
                              <div className="text-izin-usaha">
                                <span style={{ color: "red" }}>* </span>Dokumen
                                Penunjukkan Ahli Waris
                              </div>
                            </div>
                            <div className="frame-file-izin-usaha">
                              <div className="frame-sub-file-izin-usaha">
                                <div
                                  className="text-file"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    window.open(
                                      `${
                                        filePreviewUrl &&
                                        filePreviewUrl?.ahli_waris
                                          ? filePreviewUrl.ahli_waris.data
                                          : isFileChoose.ahli_waris &&
                                            isFileChoose.ahli_waris?.link
                                      }`
                                    );
                                  }}
                                >
                                  {filePreviewUrl && filePreviewUrl?.ahli_waris
                                    ? filePreviewUrl.ahli_waris.name
                                    : isFileChoose.ahli_waris &&
                                      isFileChoose.ahli_waris?.label
                                    ? isFileChoose.ahli_waris?.label
                                    : "No File Choose"}
                                </div>
                              </div>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  handleFileChange(e);
                                }}
                                ref={fileInputRef}
                                accept=".jpg,.jpeg,.png,.pdf"
                                name="ahli_waris"
                              />
                              <CustomButton
                                label="Upload File"
                                color="primary-btn"
                                className="button-file"
                                ukuran="btn-sm"
                                onClick={() => handleButtonClick("ahli_waris")}
                                disabled={isFieldDisabled}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="frame-sub-upload-dokumen">
                          <div className="frame-izin-usaha">
                            <div className="frame-sub-izin-usaha">
                              <div className="text-izin-usaha">
                                Dokumen Lainnya
                              </div>
                            </div>
                            <div className="frame-file-izin-usaha">
                              <div className="frame-sub-file-izin-usaha">
                                <div
                                  className="text-file"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    window.open(
                                      `${
                                        filePreviewUrl &&
                                        filePreviewUrl?.lainnya
                                          ? filePreviewUrl.lainnya.data
                                          : isFileChoose.lainnya &&
                                            isFileChoose.lainnya?.link
                                      }`
                                    );
                                  }}
                                >
                                  {filePreviewUrl && filePreviewUrl?.lainnya
                                    ? filePreviewUrl.lainnya.name
                                    : isFileChoose.lainnya &&
                                      isFileChoose.lainnya?.label
                                    ? isFileChoose.lainnya?.label
                                    : "No File Choose"}
                                </div>
                              </div>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                onChange={(e) => {
                                  handleFileChange(e);
                                }}
                                ref={fileInputRef}
                                accept=".jpg,.jpeg,.png,.pdf"
                                name="lainnya"
                              />
                              <CustomButton
                                label="Upload File"
                                color="primary-btn"
                                className="button-file"
                                ukuran="btn-sm"
                                onClick={() => handleButtonClick("lainnya")}
                                disabled={isFieldDisabled}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        {!isReadOnly ? (
          <div className="frame-button-simpan">
            <CustomButton
              label="Simpan"
              color={isDisable ? "secondary-btn" : "primary-btn"}
              // color={"primary-btn"}
              className="btn-simpan"
              onClick={handleSubmit}
              disabled={isDisable}
            />
          </div>
        ) : null}
      </Container>
    </>
  );
};

export default AddAnggota;
